import http from 'plugins/axios';

export default {
    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
    findBaseConfig() {
        return http.get({
            url: '/admin/stakingCoin/findBaseConfig'
        });
    },
    updateLockSwitch(data) {
        return http.post({
            url: '/admin/stakingCoin/updateLockSwitch',
            data: data,
            dataType: 'form'
        });
    },
    updateUnlockSwitch(data) {
        return http.post({
            url: '/admin/stakingCoin/updateUnlockSwitch',
            data: data,
            dataType: 'form'
        });
    },
    updateUnlock(data) {
        return http.post({
            url: '/admin/stakingCoin/updateUnlock',
            data: data,
            dataType: 'form'
        });
    },
    createStakingCoin(data) {
        return http.post({
            url: '/admin/stakingCoin/create',
            data: data,
            dataType: 'form'
        });
    },
    updateStakingCoin(data) {
        return http.post({
            url: '/admin/stakingCoin/update',
            data: data,
            dataType: 'form'
        });
    },
    getStakingCoinList(data) {
        return http.get({
            url: '/admin/stakingCoin/list',
            data: data
        });
    },
    getStakingLockList(data) {
        return http.get({
            url: '/admin/stakingLock/list',
            data: data
        });
    },
    cancleStakingLockOrder(data) {
        return http.post({
            url: '/admin/stakingLock/cancel',
            data: data,
            dataType: 'form'
        });
    },
    getStakingUnlockOrderList(data) {
        return http.get({
            url: '/admin/stakingUnlock/list',
            data: data
        });
    },
    cancleStakingUnlockOrder(data) {
        return http.post({
            url: '/admin/stakingUnlock/cancel',
            data: data,
            dataType: 'form'
        });
    },
    getIncomeList(data) {
        return http.get({
            url: '/admin/income/list',
            data: data
        });
    },
    createIncome(data) {
        return http.post({
            url: '/admin/income/create',
            data: data,
            dataType: 'form'
        });
    },
    calculateStakingAward(data) {
        return http.post({
            url: '/admin/income/createByJson',
            data: data,
            dataType: 'form'
        });
    },
    deleteIncome(data) {
        return http.post({
            url: '/admin/income/delete',
            data: data,
            dataType: 'form'
        });
    },
    grantIncome(data) {
        return http.post({
            url: '/admin/income/grant',
            data: data,
            dataType: 'form'
        });
    },
    oneKeyGrantIncome(data) {
        return http.post({
            url: ' /admin/income/grantAll',
            data: data,
            dataType: 'form'
        });
    },
    getLockingTotal(data) {
        return http.get({
            url: '/admin/income/lockingTotal',
            data: data
        });
    },
    getUnlockingTotal(data) {
        return http.get({
            url: '/admin/income/unlockingTotal',
            data: data
        });
    },
    allUnlock(data) {
        return http.post({
            url: '/admin/stakingUnlock/allUnlock',
            data: data,
            dataType: 'form'
        });
    },
    lockAndUnlock(data) {
        return http.get({
            url: '/admin/stakingCount/lockAndUnlock',
            data: data
        });
    },
    getCoinInfo(data) {
        return http.get({
            url: '/admin/stakingCoin/info',
            data: data
        });
    },
    checkGrant(data) {
        return http.post({
            url: '/admin/income/checkGrant',
            data: data,
            dataType: 'form'
        });
    },
};
